module.exports = __webpack_public_path__ + "static/Fluke@2x.c1a59a93.png";